var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEr404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 135"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 158",
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.333 88.3333H126V121.667H119.333V113.333H112.662C108.525 113.333 105.162 109.971 105.162 105.833V88.3333H111.829V105.833C111.829 106.292 112.204 106.667 112.662 106.667H119.333V88.3333ZM69.3333 106.667H62.6625C62.2042 106.667 61.8292 106.292 61.8292 105.833V88.3333H55.1625V105.833C55.1625 109.971 58.525 113.333 62.6625 113.333H69.3333V121.667H76V88.3333H69.3333V106.667ZM101 98.75V111.25C101 116.992 96.325 121.667 90.5833 121.667C84.8417 121.667 80.1667 116.992 80.1667 111.25V98.75C80.1667 93.0083 84.8417 88.3333 90.5833 88.3333C96.325 88.3333 101 93.0083 101 98.75ZM94.3333 98.75C94.3333 96.6833 92.65 95 90.5833 95C88.5167 95 86.8333 96.6833 86.8333 98.75V111.25C86.8333 113.317 88.5167 115 90.5833 115C92.65 115 94.3333 113.317 94.3333 111.25V98.75ZM44.75 42.5C41.3 42.5 38.5 45.3 38.5 48.75C38.5 52.2 41.3 55 44.75 55C48.2 55 51 52.2 51 48.75C51 45.3 48.2 42.5 44.75 42.5ZM61.4167 42.5C57.9667 42.5 55.1667 45.3 55.1667 48.75C55.1667 52.2 57.9667 55 61.4167 55C64.8667 55 67.6667 52.2 67.6667 48.75C67.6667 45.3 64.8667 42.5 61.4167 42.5ZM126 42.5V80H117.667V67.5H34.3333V113.333H51V121.667H26V42.5C26 35.6083 31.6083 30 38.5 30H113.5C120.392 30 126 35.6083 126 42.5ZM117.667 59.1667V42.5C117.667 40.2042 115.796 38.3333 113.5 38.3333H38.5C36.2042 38.3333 34.3333 40.2042 34.3333 42.5V59.1667H117.667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr404);
export default __webpack_public_path__ + "static/media/er404.881309986b294a36556245c55ebb1180.svg";
export { ForwardRef as ReactComponent };